
import Vue from "vue";
import { mapGetters } from "vuex";
import AppHeader from "@/components/AppHeader.vue";
// import AppBottomNav from "@/components/AppBottomNavigation.vue";

export default Vue.extend({
  name: "App",
  components: {
    AppHeader,
  },
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
      isCast: "auth/isCast",
    }),
  },
  methods: {
    isBgBlack(): boolean {
      return this.$route.name == "Waiting" || this.$route.name == "GuestLogin";
    },
  },
  data: () => ({
    //
  }),
});
